<template lang="pug">
  ul.tracker-legend
    li.high {{ ceilingLabel }}
    li.low {{ floorLabel }}
</template>
<script>
export default {
  name: 'TrackerLegend',
  props: {
    ceilingLabel: {
      type: String,
      required: true
    },
    floorLabel: {
      type: String,
      required: true
    }
  }
};
</script>

